<template>
	<div :class="{
		'resource-view': true,
		'compact': condensed
	}">
		<div class="header" ref="tester">
			<div class="list">
				<div class="pin" @click="togglePinned()">
					<svg-icon :class="{
						icon: true,
						active: pinned
					}" icon="pin" />
				</div>
				<div class="title" @click.stop="filterPopup($event)">
					{{ _filters.hasOwnProperty(filter) ? _filters[filter].label : '' }}
					<svg-icon class="icon" icon="arrow_down" />
				</div>
				<div class="title sorting" @click.stop="sortingPopup($event)">
					{{ sorting.options.hasOwnProperty(sorting.value) ? sorting.options[sorting.value] : '' }}
					<svg-icon class="icon" icon="arrow_down" />
				</div>
			</div>
			<div class="plan" ref="plan">
				<svg>
					<line v-for="i in 23" v-bind:key="i" :x1="((i / 24) * 100) + '%'" y1="100%" :x2="((i / 24) * 100) + '%'" y2="50px"></line>
				</svg>
				<div class="number" :style="{ left: (((i / 24) * 100) - ((0.5 / 24) * 100)) + '%' }" v-for="i in 23" v-bind:key="i">{{ i }}</div>
			</div>
		</div>
		<div class="body">
			<div class="bg">
				<div class="list"></div>
				<div class="plan">
					<svg>
						<line :class="i % 2 == 1 ? 'odd' : ''" v-for="i in 47" v-bind:key="i" :x1="((i / 48) * 100) + '%'" y1="0%" :x2="((i / 48) * 100) + '%'" y2="100%"></line>
						<line v-if="time" class="time" :x1="(((time.seconds + 1) / 86400) * 100) + '%'" y1="0%" :x2="(((time.seconds + 1) / 86400) * 100) + '%'" y2="100%"></line>
					</svg>
				</div>
			</div>
			<perfect-scrollbar class="content" style="padding: 20px 0 20px 0;">
				<transition-group appear class="role" v-for="(group, i) in _active_groups" :key="i" tag="div" name="item">
					<div v-if="false" class="title" :key="'title' + i">
						<div class="list">
							<div class="arrow" style="display: none;">X</div>
							<div class="title">{{ group.label }}</div>
						</div>
						<div class="plan">
							
						</div>
					</div>
					<div :class="{
						item: true,
						hover: hoverRes && hoverRes.id == res.id
					}" v-for="(res, j) in group.res" :key="j" @dragover="dragOver($event, res)" @dragleave="dragLeave" @drop="drop($event, res)" :style="itemStyle(res)">
						<div class="list" @mouseenter="$store.commit('hover', [res, 'right', res.type])" @mouseleave="$store.commit('hover', [null, 'right', null])">
							<div class="pos">
								<svg-icon :class="{
									up: true,
									disabled: sorting.value != 'personal' || condensed
								}" icon="arrow_up" @click="move(res, -1)" style="width: 8px; height: 8px;" />
								<svg-icon :class="{
									pin: true,
									active: res.pinned
								}" icon="pin" @click="$emit('pin', res)" style="width: 16px; height: 16px;" />
								<svg-icon :class="{
									down: true,
									disabled: sorting.value != 'personal' || condensed
								}" icon="arrow_down" @click="move(res, 1)" style="width: 8px; height: 8px;" />
							</div>
							<img class="photo" :src="res.image">
							<div class="name">{{ res.name }}</div>
							<div class="title">{{ res.title }}</div>
							<div class="status" :style="getStatusStyle(res)"></div>
							<div :class="{ time: true, personal: res.meeting_time }" @click.prevent.stop="setTime($event, res)">{{ res.meeting_time ? res.meeting_time : getTime(res) }}</div>
						</div>
						<div class="plan" :style="{...planStyle(res), ...{backgroundColor: '#a7a7a711'}}" style="" @contextmenu.prevent="$emit('resource_context', $event, res)">
							<transition-group name="track">
								<div v-for="(reservation, j) in res.reservations" :key="`reservation-${j}`" :style="{
									height: '100%',
									position: 'absolute',
									top: 0,
									backgroundColor: reservation.color + '11',
									overflow: 'hidden',
									...calcTimelinePlace(reservation)
								}" @contextmenu.prevent.stop="$emit('track_context', $event, res, reservation)">
									<div class="desc" v-if="planDesc(res).note != ''" :style="{
										backgroundColor: reservation.color,
										position: 'absolute'
									}">
										<div class="label"></div>
										<div class="note" :title="reservation.desc">{{ reservation.note == 'Andet' ? (reservation.desc ? (reservation.desc.substr(0, 8) + (reservation.desc.length > 8 ? '...' : '')) : 'Andet') : reservation.note }}</div>
									</div>									
								</div>
							</transition-group>
							<transition-group name="track" tag="div">
								<div class="track" v-for="(track, i) in res.tracks" :key="i" style="pointer-events: none;">
									{{ /* @mouseenter="$store.commit('hover', [item.task, 'left'])" @mouseleave="$store.commit('hover', [null, 'left'])" */ }}
									<div class="task" v-for="(item, j) in track" :key="j" :style="{...taskStyle(item), ...{ pointerEvents: 'all' }}" :draggable="true" @dragstart="$emit('onDragStart', item.task, item.team, item.booking)" @dragend="$emit('onDragEnd')" v-touch:touchhold.self="context('context', item.booking, res, item.task)" @contextmenu.prevent.stop="$emit('context', $event, item.booking, res, item.task)" @mouseenter="$store.commit('hover', [item.task, 'left', 'task'])" @mouseleave="$store.commit('hover', [null, 'left', null])">
										<div class="color" :style="{ backgroundColor: types.hasOwnProperty(item.task.type) ? types[item.task.type].color : 'yellow' }">{{ condensed ? $options.filters.striphtml(getInfo(item.task)) : '' }}</div>
										<div class="body">
											<div class="title">#{{ item.task.num }} {{ item.task.name }}</div>
											<div class="zip" v-html="getInfo(item.task)"></div>
											<div v-show="item.task.type == 'survey' && item.task._embedded.related.orders.length > 0" class="dot"></div>
										</div>
										<div @mousedown.prevent="dragLeftStart($event, item.booking)" @mouseenter="$store.commit('hover', [null, 'left', null])" @mouseleave="$store.commit('hover', [item.task, 'left', 'task'])" class="left">&lt;</div>
										<div @mousedown.prevent="dragRightStart($event, item.booking)" @mouseenter="$store.commit('hover', [null, 'left', null])" @mouseleave="$store.commit('hover', [item.task, 'left', 'task'])" class="right">&gt;</div>
									</div>								
								</div>
							</transition-group>
						</div>
					</div>
				</transition-group>
			</perfect-scrollbar>
			<legend-view :items="taskTypes" />
		</div>
	</div>
</template>

<script>
	import DragTargetMixin from '../../mixins/DragTargetMixin'
	import CompareDatesMixin from '../../mixins/CompareDatesMixin'
	import WeekNumberMixin from '../../mixins/WeekNumberMixin'
	import LegendView from './LegendView'
	import { bus } from '../../bus'

	import ContextPopupView from './ContextPopupView'

	export default {
		mixins: [
			DragTargetMixin,
			CompareDatesMixin,
			WeekNumberMixin
		],
		components: {
			LegendView
		},
		data: function () {
			return {
				dragside: {
					origin: null,
					side: null,
					booking: null,
				},
				type: null,
				timer: null,
				time: null,
				tab: null,
				taskTypes: [],
				sorting: {
					value: 'personal',
					options: {
						personal: 'Personlig',
						alpha: 'Alfabetisk'
					}
				},
				pinned: false
				//hoverRes: null
			};
		},
		props: {
			filter: {
				type: String,
				default: null
			},
			filters: {
				type: Array,
				default() {
					return [];
				}
			},
			condensed: {
				type: Boolean,
				default: true
			},
			planned: {
				type: Boolean,
				default: true
			},
			free: {
				type: Boolean,
				default: true
			},
			internal: {
				type: Boolean,
				default: true
			},
			external: {
				type: Boolean,
				default: true
			},
			info: {
				type: String,
				default: 'zip'
			},
			drag: {
				type: Object,
				default() {
					return null;
				}
			},
			hover: {
				type: Object,
				default() {
					return null;
				}
			},
			hoverRes: {
				type: Object,
				default() {
					return null;
				}
			},
			resources: {
				type: Array,
				default: function () {
					return [];
				}
			},
			types: {
				type: Object,
				default: function () {
					return {};
				}
			},
			reservations: {
				type: Array,
				default: function () {
					return [];
				}
			},
			tasks: {
				type: Array,
				default: function () {
					return [];
				}
			},
			bookings: {
				type: Array,
				default: function () {
					return [];
				}
			},
			date: String
		},
		watch: {
			date() {
				if (this.compareDates(Date.normDate(this.date), new Date()) == 0) {
					this.startTimer();
				} else {
					this.stopTimer();
				}
			},
			drag(n, o) {
				if (n === null) {
					this.hover = null;
				}
			},
			_groups() {
				//

				if (!this.tab && this._groups.length > 0) {
					this.tab = this._groups[0].label;
				} else if (this._groups.length == 0) {
					this.tab = null;
				}
			}
		},
		computed: {
			_filters() {
				if (!Array.isArray(this.filters)) return {}; 

				var r = {};

				for (var i = 0; i < this.filters.length; ++i) {
					if (this.filters[i] === null) continue;
					r[this.filters[i].value] = this.filters[i];
				}

				return r;
			},
			_tabs() {
				return this._groups.map(function (group) {
					return {
						label: group.label,
						value: group.label,
						badge: null
					};
				});
			},

			indexedTypes() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				return r;
			},
			sortedResources() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = {};

					for (var j = 0; j < this.types[i].roles.length; ++j) {
						r[this.types[i].name][this.types[i].roles[j].name] = [];
					}
				}

				for (var i = 0; i < this.resources.length; ++i) {
					for (var j = 0; j < this.resources[i].roles.length; ++j) {
						

						
							r[this.resources[i].type][this.resources[i].roles[j]].push(this.resources[i]);
						
					}
				}

				return r;
			},
			_reservations() {
				var r = {};

				// Pre populate
				for (var i = 0; i < this.resources.length; ++i) {
					r[this.resources[i].type + this.resources[i].id] = [];
				}

				//

				for (var i = 0; i < this.reservations.length; ++i) {
					var reserve = this.reservations[i];

					//if (reserve.status == 'denied') continue;

					// Add employees
					if (r.hasOwnProperty(reserve.type + reserve.id)) {
						r[reserve.type + reserve.id].push(reserve);
					}
				}

				

				return r;
			},
			_tasks() {
				var r = {};

				for (var i = 0; i < this.tasks.length; ++i) {
					r[this.tasks[i].id] = this.tasks[i];
				}

				return r;
			},
			_resources() {
				var self = this;

				var rs = Array.isArray(this.resources) ? this.resources.map(function (res) {
					res.visible = res.filters.indexOf(self.filter) > -1 && !(self.pinned && !res.pinned); //res.group == self.tab;
					res.tracks = self.getTracks(res);

					return res;
				}) : [];

				// SORT HERE
				if (this.sorting.value == 'personal') {
					
					rs.sort(function (a, b) { return a.order >= b.order ? 1 : -1; });
				}

				if (this.sorting.value == 'alpha') {
					
					rs.sort(function (a, b) { return a.name >= b.name ? 1 : -1; });
				}

				return rs;
			},
			_active() {
				return this._resources.filter((item) => { return item.active; });
			},
			_groups() {
				var r = [];

				for (var i = 0; i < this._resources.length; ++i) {
					/*if (this.pinned && !this._resources[i].pinned) {
						continue;
					}*/

					var match = false;

					for (var j = 0; j < r.length; ++j) {
						if (r[j].label == this._resources[i].group) {
							r[j].res.push(this._resources[i]);
							match = true;
							break;
						}
					}

					if (!match) {
						r.push({
							label: this._resources[i].group,
							res: [this._resources[i]]
						});
					}
				}

				return r;
			},
			_active_groups() {
				var r = [];

				for (var i = 0; i < this._active.length; ++i) {
					/*if (this.pinned && !this._resources[i].pinned) {
						continue;
					}*/

					var match = false;

					for (var j = 0; j < r.length; ++j) {
						if (r[j].label == this._active[i].group) {
							r[j].res.push(this._active[i]);
							match = true;
							break;
						}
					}

					if (!match) {
						r.push({
							label: this._active[i].group,
							res: [this._active[i]]
						});
					}
				}

				return r;
			},
			_bookings() {
				var r = {};
				var id;

				//

				for (var i = 0; i < this.bookings.length; ++i) {
					id = this.bookings[i].res_type + '_' + this.bookings[i].res_id;

					//

					if (r.hasOwnProperty(id)) {
						//
						r[id].push(this.bookings[i]);
					} else {
						r[id] = [this.bookings[i]];
					}
				}

				//

				return r;
			}
		},
		methods: {
			dragSideMove($event) {
				const delta = $event.screenX - this.dragside.origin;
				const min = (delta / this.dragside.width) * (24 * 60);
				const t = this.dragside[this.dragside.side].getTime() + min * 60 * 1000;

				// Snap t to nearest half hour
				const part = t % (30 * 60 * 1000);
				const round = Math.round(part / (30 * 60 * 1000));
				const snap = t - part + round * (30 * 60 * 1000);

				const d = new Date(snap);

				const map = {
					left: 'from',
					right: 'to',
				};

				this.dragside.booking[map[this.dragside.side]] = d.format("Y-m-d H:i:s");
			},
			dragSideStart($event, side, booking) {
				const self = this;

				this.$nextTick(() => {
					console.log('drag start', side, booking, $event.screenX, self.$refs.plan.offsetWidth);

					const width = self.$refs.plan.offsetWidth;
					const min = width / (24 * 60);

					console.log(min);

					self.dragside = {
						width,
						min,
						origin: $event.screenX,
						side,
						booking,
						left: new Date(booking.from),
						right: new Date(booking.to),
					};

					window.addEventListener('mousemove', self.dragSideMove);
					window.addEventListener('mouseup', self.dragSideEnd);
				});
			},
			dragSideEnd($event) {
				console.log('drag end', this.dragside);

				window.removeEventListener('mousemove', this.dragSideMove);
				window.removeEventListener('mouseup', this.dragSideEnd);

				this.$emit('updateBooking', this.dragside.booking);
			},
			dragLeftStart($event, booking) {
				this.dragSideStart($event, 'left', booking);
			},
			dragRightStart($event, booking) {
				this.dragSideStart($event, 'right', booking);
			},
			move(res, rel) {
				if (this.sorting.value != 'personal' || this.condensed) return;
				

				// Find over and under
				var idOver = null;
				var idUnder = null;

				var bOver = null;
				var passed = false;

				for (var i = 0; i < this._resources.length; ++i) {
					var r = this._resources[i];

					if (idOver === null && r.visible && r.id != res.id) {
						bOver = r.id;
					}

					if (r.visible && passed) {
						idUnder = r.id;
						passed = false;
					}

					if (r.id == res.id) {
						passed = true;

						if (bOver !== null) {
							idOver = bOver;
						}
					}

					
				}

				

				var ids = [];

				if (rel == -1 && idOver !== null) {
					

					for (var i = 0; i < this._resources.length; ++i) {
						var r = this._resources[i];
						
						if (!r.visible) continue;
						if (r.id == res.id) continue;
						if (r.id == idOver) ids.push(res);
						ids.push(r);
					}
				} else if (rel == 1 && idUnder !== null) {
					

					for (var i = 0; i < this._resources.length; ++i) {
						var r = this._resources[i];

						if (!r.visible) continue;
						if (r.id == res.id) continue;
						ids.push(r);
						if (r.id == idUnder) ids.push(res);
					}
				} else {
					for (var i = 0; i < this._resources.length; ++i) {
						var r = this._resources[i];

						if (!r.visible) continue;
						ids.push(r);
					}
				}

				this.$emit('move', ids);
			},
			getTime(res) {
				return res.tracks.length > 0 && res.tracks[0][0].task.meeting_time ? res.tracks[0][0].task.meeting_time.substr(0, 5) : '-';
			},
			context(booking, res, task) {
				var self = this;

				return function (event) {
					
					self.$emit('context', event.target, booking, res, task);
				}
			},
			async setTime(event, res) {
				

				var self = this;

				var actions = [];

				if (res.type == 'employee') {
					actions.push({
						label: 'Personlig mødetid',
						action: function () {
							var t 		= '07:00';
							var d		= self.date;
							var empId	= res.id;

							return async function () {
								var time = prompt('Tidspunkt?', t);
								if (time === null) return;
								await self.axios.put('/employees/' + empId + '/meeting-time/', { date: d, time: time });
								bus.$emit('update');
							};
						}()
					});
				}

				if (res.tracks.length > 0 && res.tracks[0].length > 0) {
					actions.push({
						label: 'Mødetid på første opgave',
						action: function () {
							var t 		= (new Date(res.tracks[0][0].task.from.time)).format('H:i');
							var taskId 	= res.tracks[0][0].task.id;

							return async function () {
								var time = prompt('Tidspunkt?', t);
								if (time === null) return;
								await self.axios.put('/tasks/' + taskId + '/meeting-time/', { time: time });
								bus.$emit('update');
							};
						}()
					});
				}

				if (actions.length == 0) {
					alert('Det er ikke muligt at sætte mødetid for denne ressource');
					return;
				}

				

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event,
					actions: actions
				});		
			},
			zipCodes(s) {
				if (s.from.zip == s.to.zip || s.to.zip == '') {
					return s.from.zip;
				} else {
					return s.from.zip + ' til ' + s.to.zip;
				}
			},
			getInfo(task) {
				if (this.info == 'zip') {
					return this.zipCodes(task.route[0]);
				}

				if (this.info == 'arrival') {
					return this.$options.filters.timestamp(task.from.time);
				}

				if (this.info == 'volume') {
					return task.secondary;
				}

				if (this.info == 'summary') {
					return task.summary;
				}
			},
			getStatusStyle(res) {
				if (res.type == 'employee') {
					//
					var colors = {
						out:	'#f7223f',
						in: 	'#00c017',
						resume:	'#00c017',
						pause: 	'#ffcf00'
					};
					var bg = colors[res.status];

					return {
						position: 'absolute',
						width: '12px',
						height: '12px',
						left: this.condensed ? '50px' : '85px',
						top: this.condensed ? '4px' : '10px',
						border: '3px solid white',
						borderRadius: '50%',
						backgroundColor: bg
					};
				} else {
					return {
						display: 'none'
					};
				}
			},
			itemStyle(res) {
				var tracks = this.getTracks(res);
				var height;
				var opacity = 1;
				var pointerEvents = 'auto';
				var marginBottom = 10;

				if (this.condensed) {
					height = tracks.length > 1 ? (tracks.length * 16) + 2 : 18;			
				} else {
					height = tracks.length > 1 ? (tracks.length * 63) + 5 : 63 + 5;	
				}

				if (!res.visible) {
					height = 0;
					opacity = 0;
					pointerEvents = 'none';
					marginBottom = 0;
				}

				return {
					height: height + 'px',
					opacity: opacity,
					pointerEvents: pointerEvents,
					marginBottom: marginBottom + 'px'
				};
			},
			planColor(res) {
				var color = '#a7a7a7';
				//var cl = '#00000000';

				if (this._reservations[res.type + res.id].length > 0) {
					var r = this._reservations[res.type + res.id][0];

					//

					//background-color: #00c01623;
							/*background-color: #f5ed0333;
							background-color: #f7223e27;*/

					color = r.color;

					/*if (r.booking) {
						color = 'blue';
					}*/

					/*if (r.blocking) {
						color = '#f7223e27';
					}

					//

					if (r.status == 'requested') {
						color = '#f5ed0333';
					}*/
				}

				return color;
			},
			planStyle(res) {
				/*var tracks = this.getTracks(res);

				if (this.condensed) {
					var height = tracks.length > 1 ? (tracks.length * 16) + 2 : 18;			
				} else {
					var height = tracks.length > 1 ? (tracks.length * 63) + 5 : 63 + 5;	
				}*/

				var color = this.planColor(res) + '11';
				var cl = '#00000000';

				//

				

				return {
					backgroundColor: color,
					color: 'black'
				};
			},
			planDesc(res) {
				var s = {
					label: '',
					note: ''
				};

				//

				if (this._reservations[res.type + res.id].length > 0) {
					var r = this._reservations[res.type + res.id][0];

					//

					//background-color: #00c01623;
							/*background-color: #f5ed0333;
							background-color: #f7223e27;*/

					s.label = r.label;
					s.note = r.note;
				}

				return s;
			},
			taskStyle(item) {
				//var stop = item.task.route[item.stopIdx];
				var day = 24 * 60;

				//

				var left = 0;
				var from = Date.normDate(item.booking.from);

				if (from.format('Y-m-d') == this.date) {
					left = (from.getHours() * 60) + from.getMinutes();
				}

				var right = day;
				var to = Date.normDate(item.booking.to);

				if (to.format('Y-m-d') == this.date) {
					right = (to.getHours() * 60) + to.getMinutes();
				}

				var width = right - left;

				return {
					left: ((left / day) * 100) + '%',
					width: ((width / day) * 100) + '%',
					backgroundColor: item.task.closed === null ? 'white' : '#00C017',
					color: item.task.closed === null ? 'black' : 'white'
				};
			},
			calcTimelinePlace(item) {
				//var stop = item.task.route[item.stopIdx];
				var day = 24 * 60;

				//

				var left = 0;
				var from = Date.normDate(item.from);

				if (from.format('Y-m-d') == this.date) {
					left = (from.getHours() * 60) + from.getMinutes();
				}

				var right = day;
				var to = Date.normDate(item.to);

				if (to.format('Y-m-d') == this.date) {
					right = (to.getHours() * 60) + to.getMinutes();
				}

				var width = right - left;

				return {
					left: ((left / day) * 100) + '%',
					width: ((width / day) * 100) + '%'
				};
			},
			dateRangeOverlaps(id, a_start, a_end, b_start, b_end) {
				/*if (id == 76) {
					
					
					
					
				}*/

				//return true;
				if ((a_start > b_start && a_start < b_end) || (a_end > b_start && a_end < b_end))	return true; // a in b
				if ((b_start > a_start && b_start < a_end) || (b_end > a_start && b_end < a_end))	return true; // b in a
				if (a_start.getTime() == b_start.getTime() 	&& a_end.getTime()	== b_end.getTime())	return true; // equal

				return false;
			},
			doesFit(track, booking) {
				//var stop = task.task.route[task.stopIdx];

				//

				//

				for (var i = 0; i < track.length; ++i) {
					var b = track[i].booking;

					// Overlap ?
					if (this.dateRangeOverlaps(b.res_id, Date.normDate(b.from), Date.normDate(b.to), Date.normDate(booking.from), Date.normDate(booking.to))) {
						//if (b.res_id == 76) 

						return false;
					}
				}

				//if (b.res_id == 76) 

				return true;
			},
			getTracks(res) {
				//
				var id = res.type + '_' + res.id;

				

				//
				//
				//
				//

				


			

				if (this._bookings.hasOwnProperty(id)) {
					var bookings = this._bookings[id];
					var tracks = [];



					//

					//

					for (var i = 0; i < bookings.length; ++i) {
						if (!this._tasks.hasOwnProperty(bookings[i].task_id)) {
							//
							continue;
						}

						var task = this._tasks[bookings[i].task_id];
						var foundTrack = false;
						var team = task.teams.find(function (team) {
							return team.id == bookings[i].team_id;
						});

						for (var j = 0; j < tracks.length; ++j) {
							if (this.doesFit(tracks[j], bookings[i])) {
								tracks[j].push({
									task: task,
									team: team,
									booking: bookings[i]
								});
								foundTrack = true;
								break;
							}
						}

						if (!foundTrack) {
							tracks.push([{
								task: task,
								team: team,
								booking: bookings[i]
							}]);
						}

						//
					}

					//

					return tracks;
				} else {
					return [];
				}

				/*if (this._tasks.hasOwnProperty(res.type + res.id)) {
					var tasks = this._tasks[res.type + res.id];
					var tracks = [];

					for (var i = 0; i < tasks.length; ++i) {
						var foundTrack = false;

						for (var j = 0; j < tracks.length; ++j) {
							if (this.doesFit(tracks[j], tasks[i])) {
								tracks[j].push(tasks[i]);
								foundTrack = true;
								break;
							}
						}

						if (!foundTrack) {
							tracks.push([tasks[i]]);
						}
					}

					return tracks;
				} else {
					return [];
				}*/
			},
			updateTime() {
				var d = new Date();

				this.time = {
					label: this.getFormattedDate(d, 'H:i'),
					seconds: (d.getHours() * 3600) + (d.getMinutes() * 60) + d.getSeconds()
				};
			},
			startTimer() {
				var v = this;

				this.stopTimer();
				this.updateTime();				

				this.timer = setInterval(function () {
					v.updateTime();
				}, 1000);
			},
			stopTimer() {
				if (this.timer !== null) {
					clearInterval(this.timer);
					this.timer = null;
					this.time = null;
				}
			},
			dragOver(e, res) {
				e.preventDefault();
				//this.hoverRes = res;
				this.$emit('hover', res);
			},
			dragLeave(e, res) {
				e.preventDefault();
				//this.hoverRes = res;
				this.$emit('hover', null);
			},
			drop(e, res) {
				

				if (this.drag.type == 'task') {
					if (this.drag.booking) {
						this.$emit('book', this.drag.booking.from, this.drag.booking.to, this.drag.task.id, this.drag.team.id, res.type, res.id, this.drag.booking);
					} else {
						this.$emit('book', this.drag.task.from.time, this.drag.task.to.time, this.drag.task.id, this.drag.team.id, res.type, res.id, this.drag.booking);
					}
				}

				if (this.drag.type == 'employee') {
					
					this.$emit('copyBookings', this.drag.emp, res.bookings);
				}
			}, 
			unbook(item, res) {
				

				this.$emit('unbook', item, res);

				/*res.id = null;
				this.$emit('book', {
					task: task,
					requirement: req,
					stopIdx: stopIdx,
					reqIdx: reqIdx,
					teamIdx: teamIdx
				}, res);*/
			},
			filterPopup(event) {
				var actions = [];
				var self = this;

				for (var i = 0; i < this.filters.length; ++i) {
					if (this.filters[i] === null) {
						actions.push(null);
						continue;
					}

					actions.push({
						label: this.filters[i].label,
						highlight: this.filters[i].highlight,
						action: function () {
							var name = self.filters[i].value;

							return function () {
								self.$emit('filter', name);
							};
						}()
					});
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
			sortingPopup(event) {
				var actions = [];
				var self = this;

				for (var i in this.sorting.options) {
					actions.push({
						label: this.sorting.options[i],
						action: function () {
							var name = i;

							return function () {
								self.sorting.value = name;
							};
						}()
					});
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'right',
					actions: actions
				});
			},
			togglePinned() {
				this.pinned = !this.pinned;
			}
		},
		created() {
			if (this.types.length > 0) {
				this.type = this.types[0].name;
			}

			if (this.compareDates(Date.normDate(this.date), new Date()) == 0) {
				this.startTimer();
			}

			var self = this;

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.taskTypes = r.data._items;
				});
		},
		destroyed() {
			this.stopTimer();
		}
	}
</script>

<style lang="scss" scoped>
	.resource-view {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 60px 1fr;

		& > .header {
			border-bottom: 4px solid #f0f0f0;
			background-color: white;

			& > .list, & > .plan {
				height: 100%;
			}

			& > .list {
				border-right: 2px solid #cecece;
				position: relative;
				cursor: pointer;
				display: grid;
				grid-template-columns: 50px 1fr auto;
				grid-template-rows: 54px;

				& > .pin {
					& > .icon {
						width: 16px;
						height: 16px;
						margin: 19px 0 0 18px;
						fill: #CECECE;

						&.active {
							fill: black;
						}
					}					
				}

				& > .title {
					position: relative;
					font-size: 14px;
					font-weight: bold;
					line-height: 54px;
				}

				& > .title > .icon {
					width: 8px;
					height: 8px;
					margin-top: 5px;
					margin-left: 5px;
					margin-right: 19px;
				}

				& > .sorting {
					fill: rgb(145, 145, 145);
					color: rgb(145, 145, 145);
					font-weight: normal;
				}
			}

			& > .plan {
				position: relative;

				& > svg {
					width: 100%;
					height: 100%;

					& > line {
						stroke: #cecece;
						stroke-width: 1;
					}
				}

				& > .number {
					position: absolute;
					top: 0;
					height: 56px;
					line-height: 56px;
					text-align: center;
					width: 4.167%;
					font-size: 14px;
					font-weight: bold;
				}
			}
		}

		& > .header, & > .body > .content > .role > * {
			display: grid;
			grid-template-columns: 430px 1fr;
		}

		& > .header, & > .body > .content > .role > * {
			& > .list {
				position: relative;
			}
		}

		& > .body {
			position: relative;

			& > .bg {
				position: absolute;
				width: 100%;
				top: 0;
				bottom: 0;

		
				& > .list {
					border-right: 2px solid #cecece;
					background-color: white;
					left: 0;
					top: 0;
					height: 100%;
					width: 430px;
				}

				& > .plan {
					background-color: #F0F0F0;
					overflow: hidden;
					position: absolute;
					left: 430px;
					right: 0;
					top: 0;
					height: 100%;

					& > svg {
						width: 100%;
						height: 100%;

						& > line {
							stroke: #e1e1e1; 
							stroke-width: 1;

							&.odd {
								stroke-dasharray: 5px;
							}

							&.time {
								stroke: #F7223F;
							}
						}
					}
					
				}
			}

			& > .content {
				position: absolute;
				overflow-x: hidden;
				overflow-y: auto;
				width: 100%;
				height: 100%;

				& > .role {
					& > * > .list {
						height: 68px;
					}

					& > .title > .list {
						height: 45px;
						position: relative;

						& > .title {
							font-size: 16px;
							font-weight: bold;
							padding-left: 50px;
							padding-top: 10px;
							line-height: 35px;
						}

						& > .arrow {
							position: absolute;
							left: 15px;
							top: 10px;
							width: 35px;
							height: 35px;
							line-height: 35px;
							text-align: center;
						}
					}

					& > .item {
						margin-bottom: 10px;
						/*max-height: 500px;*/
						transition: height 0.25s, margin-bottom 0.25s, opacity 0.25s;

						& > .list {
							& > .pos {
								display: grid;
								grid-template-columns: 16px;
								grid-template-rows: 1fr 1fr 1fr;
								height: 100%;
								margin-left: 20px;
								align-items: center;

								& > * {
									cursor: pointer;
									fill: #CECECE;
								}

								& > .up, & > .down {
									width: 8px;
									margin-left: 4px;
									opacity: 0;
								}

								& > .pin {
									opacity: 0;

									&.active {
										fill: black;
										opacity: 1;
									}
								}

								& > .down {
									
								}
							}

							& > .photo {
								width: 48px;
								height: 48px;
								border-radius: 50%;
								position: absolute;
								left: 50px;
								top: 10px;

							}

							& > .name {
								position: absolute;
								left: 115px;
								top: 14px;
								height: 20px;
								line-height: 20px;
								font-size: 14px;

								transition: left 0.25s, top 0.25s;
							}

							& > .title {
								position: absolute;
								left: 115px;
								bottom: 14px;
								height: 20px;
								line-height: 20px;
								font-size: 12px;
								color: #a7a7a7;

						
							}

							& > .status {
								position: absolute;
								left: 84px;
								top: 8px;
								width: 8px;
								height: 8px;
								border: 1px solid white;

					
							}

							& > .time {
								position: absolute;
								top: 14px;
								right: 30px;
								color: #a7a7a7;
								font-size: 12px;
								text-align: right;
								cursor: pointer;

								&.personal {
									text-decoration: underline;
								}
							}
						}

						&:hover > .list > .pos {
							& > .up, & > .down, & > .pin {
								opacity: 1;
							}
						}

						& > .list > .pos {
							& > .up.disabled, & > .down.disabled {
								opacity: 0;
								cursor: default;
								pointer-events: none;
							}
						}

						& > .plan {
							padding-top: 5px;
							position: relative;
							/*max-height: 500px;*/
							transition: height 0.25s, background-color 0.25s;

							& > * > * > .desc {
								position: absolute;
								left: 0;
								top: 0;
								color: white;
								padding: 3px 5px 3px 5px;
								opacity: 0.7;
								border-radius: 0 0 5px 0;
								overflow: hidden;
								
								> .note {
									white-space: nowrap;
									font-size: 12px;
								}
							}

							& > div > .track {
								margin-bottom: 5px;
								height: 58px;
								position: relative;
								
								& > .task {
									box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

									display: grid;
									height: 58px;
									background-color: white;
									border-radius: 5px;
									overflow: hidden;
									grid-template-columns: 5px 1fr;
									position: absolute;
									cursor: grab;

									& > .color {

									}

									& > .body {
										padding: 5px;

										& > .title {
											font-weight: bold;
											white-space: nowrap;
										}

										& > .zip {
											margin-top: 10px;
											white-space: nowrap;
										}

										& > .dot {
											position: absolute;
											right: 0;
											bottom: 0;
											width: 10px;
											height: 10px;
											border-radius: 50%;
											background-color: rgb(0, 192, 23);
											border: 1px solid white;
										}
									}									
								}
							}
						}

						&.hover {
							background-color: #00c01623;
							/*background-color: #f5ed0333;
							background-color: #f7223e27;*/

							&.error {
								background-color: #f7223e27;
							}
						}
					}
				}
			}
		}
	}

	.resource-view.compact {
		& > .body {
			& > .content {
				& > .role {
					& > .item {
						& > .list {
							height: 20px;

							& > .name {
								left: 65px;
								top: 0;
								height: 20px;
								line-height: 20px;
							}

							& > .photo, & > .title {
								opacity: 0;
								pointer-events: none;
							}

							& > .time {
								top: 0;
							}
						}

						& > .plan {
							padding-top: 2px;

							& > * > * > .desc {
								display: none;
							}

							& > div > .track {
								height: 16px;
								margin-bottom: 2px;

								& > .task {
									height: 16px;
									
									display: block;

									& > .color {
										width: 100%;
										height: 100%;
										color: white;
										font-size: 10px;
										line-height: 16px;
										padding-left: 5px;
									}

									& > .body {
										display: none;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.item-enter-active, .item-leave-active {
		transform: translateY(0);
		transition: opacity .25s, transform .25s, height .25s, margin-bottom .25s;
	}
	
	.item-enter, .item-leave-to /* .fade-leave-active below version 2.1.8 */ {
		
		opacity: 0;
		height: 0px;
		margin-bottom: 0px ! important;
	}

	.item-leave-to {
		transition-delay: 0ms ! important;
	}

	.track-enter-active, .track-leave-active {
		transform: translateY(0);
		transition: opacity 0.25s, transform 0.25s;
	}
	
	.track-enter, .track-leave-to /* .fade-leave-active below version 2.1.8 */ {
		
		opacity: 0;
	}

	.track-leave-to {
		transition-delay: 0ms ! important;
	}

	.task {
		overflow: visible ! important;

		& > .color {
			border-radius: 5px 0 0 5px;
		}

		& > .body {
			overflow: hidden;
		}

		& > .left, & > .right {
			z-index: 1000000;
			display: none;
			position: absolute;
			top: 50%;
			width: 22px;
			height: 22px;
			border-radius: 50%;
			background-color: #f7223f;
			border: 1px solid white;
			color: white;
			margin-top: -11px;
			line-height: 20px;
			text-align: center;
			cursor: ew-resize;
			font-weight: bold;
			font-size: 12px;
		}

		& > .left {
			left: -11px;
		}

		& > .right {
			right: -11px;
		}

		&:hover {
			& > .left, & > .right {
				display: block;
			}
		}
	}
</style>